document.addEventListener('click', function (e) {
  var btn = e.target.closest('.klaviyo-bis-trigger');
  if (!btn) return;
  
  e.preventDefault();
  
  var isMobile = window.matchMedia('(max-width: 767px)').matches;
  
  var desktopFormId = btn.dataset.formId;
  var mobileFormId = btn.dataset.mobileFormId;

  var formId = isMobile && mobileFormId
    ? mobileFormId
    : desktopFormId;

  var variantId = btn.dataset.variantId;

  if (!formId) return;

  // Pass variant context to Klaviyo before opening the form so BIS
  // subscriptions are correctly associated with the specific variant,
  // including when triggered from a collection page card.
  if (variantId) {
    window.klaviyoBisVariantId = variantId;
  }
  window._klOnsite = window._klOnsite || [];
  window._klOnsite.push(['openForm', formId]);
});